import { render, staticRenderFns } from "./RightRelatorios.vue?vue&type=template&id=4cceb9c7"
import script from "./RightRelatorios.vue?vue&type=script&lang=js"
export * from "./RightRelatorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports